import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/components/Layout";
import { NewBundleDialog } from "@/components/NewBundleDialog";
import { api } from "@/lib/api";

const KIND = { pair: "Bundle", series: "Complete series" };

export default function Bundles() {
  const [list, setList] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    api.get("/bundles").then((r) => setList(r.data));
  }, []);

  return (
    <div>
      <PageHeader eyebrow="Sell titles together" title="Bundles">
        <Button onClick={() => setOpen(true)} className="rounded-none bg-[#5E2B38] hover:bg-[#4A2029] gap-2" data-testid="new-bundle-btn">
          <Plus size={16} /> New bundle
        </Button>
      </PageHeader>
      <div className="px-6 md:px-12 py-10">
        {list && !list.length && (
          <div className="border border-dashed border-[#2A2325]/20 p-12 text-center text-[#5C5255]" data-testid="bundles-empty">
            <Package className="mx-auto mb-3 text-[#9A6B2F]" />
            No bundles yet. Pair a guide with an AI workbook, pick titles, or bundle a complete series.
          </div>
        )}
        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-6">
          {(list || []).map((b) => (
            <Link key={b.id} to={`/bundles/${b.id}`} data-testid={`bundle-card-${b.id}`}
              className="block border border-[#2A2325]/10 bg-[#FFFDF9] p-6 hover:-translate-y-0.5 hover:shadow-md transition-[transform,box-shadow]">
              <div className="flex items-center justify-between">
                <span className="eyebrow">{KIND[b.kind]}</span>
                {b.store_sync?.status === "done" && b.published && <span className="text-[10px] tracking-widest bg-[#2F5D50] text-white px-2 py-0.5">LIVE</span>}
                {b.stale && <span className="text-[10px] tracking-widest bg-[#F3E5AB] px-2 py-0.5">NEEDS UPDATE</span>}
              </div>
              <h3 className="font-display text-2xl mt-2 leading-tight">{b.title}</h3>
              <p className="text-sm text-[#5C5255] mt-1">{b.items.length} titles{b.price ? ` · A$${b.price}` : ""}{b.saving ? ` · saves A$${b.saving}` : ""}</p>
              <ul className="mt-3 text-sm space-y-0.5">
                {b.items.slice(0, 4).map((i) => <li key={i.id} className="truncate">— {i.title}</li>)}
              </ul>
            </Link>
          ))}
        </div>
      </div>
      <NewBundleDialog open={open} onOpenChange={setOpen} />
    </div>
  );
}
